import React, { ReactElement, useState } from 'react';
import { FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import { Form } from 'common/components/antd/Form/Form';
import { Input } from 'common/components/antd/Input/Input';
import { STitle, SEnhancedSelect, SContainer } from './filters-form.component.style';
import { EPermissionsFilterFormKeys } from '../../enums/permissions.enums';

type TProps = {
  onSubmit: (values: any) => void;
  form: FormInstance;
  isLoading: boolean;
};

export const FiltersFormComponent = ({ onSubmit, form, isLoading }: TProps): ReactElement => {
  const { t } = useTranslation();
  const [permissionTypeValue, setPermissionTypeValue] = useState<string | null>(null);
  const [permissionKindValue, setPermissionKindValue] = useState<string | null>(null);

  const PERMISSION_TYPE_OPTIONS = [
    {
      value: 'GET',
      label: 'GET',
    },
    {
      value: 'POST',
      label: 'POST',
    },
    {
      value: 'PUT',
      label: 'PUT',
    },
    {
      value: 'DELETE',
      label: 'DELETE',
    },
  ];

  const PERMISSION_KIND_OPTIONS = [
    {
      value: 'endpoint',
      label: t('usrRoleMng.permissions.filters.kind.options.endpoint'),
    },
    {
      value: 'branch',
      label: t('usrRoleMng.permissions.filters.kind.options.branch'),
    },
  ];

  const permissionType = {
    value: permissionTypeValue,
    setValue: setPermissionTypeValue,
    onChange: (value: string): void => {
      setPermissionTypeValue(value);
    },
    options: PERMISSION_TYPE_OPTIONS,
  };

  const permissionKind = {
    value: permissionKindValue,
    setValue: setPermissionKindValue,
    onChange: (value: string): void => {
      setPermissionKindValue(value);
    },
    options: PERMISSION_KIND_OPTIONS,
  };

  return (
    <SContainer>
      <STitle>{t('usrRoleMng.permissions.filters.title')}</STitle>
      <Form onFinish={onSubmit} form={form}>
        <Form.Item name={EPermissionsFilterFormKeys.GUID}>
          <Input
            placeholder={t('usrRoleMng.permissions.filters.guid.placeholder') as string}
            size="middle"
            allowClear
          />
        </Form.Item>
        <Form.Item name={EPermissionsFilterFormKeys.Type}>
          <SEnhancedSelect
            size="middle"
            value={permissionType.value}
            placeholder={t('usrRoleMng.permissions.filters.type.placeholder')}
            onChange={permissionType.onChange}
            options={permissionType.options}
            allowClear
          />
        </Form.Item>
        <Form.Item name={EPermissionsFilterFormKeys.Scope}>
          <Input
            placeholder={t('usrRoleMng.permissions.filters.scope.placeholder') as string}
            size="middle"
            allowClear
          />
        </Form.Item>
        <Form.Item name={EPermissionsFilterFormKeys.Kind}>
          <SEnhancedSelect
            size="middle"
            value={permissionKind.value}
            placeholder={t('usrRoleMng.permissions.filters.kind.placeholder')}
            onChange={permissionKind.onChange}
            options={permissionKind.options}
            allowClear
          />
        </Form.Item>
        <Button type="primary" htmlType="submit" width="100%" disabled={isLoading} loading={isLoading}>
          {t('usrRoleMng.permissions.filters.button.filter')}
        </Button>
      </Form>
    </SContainer>
  );
};
